import { runRoutine, runAsyncRoutine } from './runners';
//type InferDeps<G> = UnionToIntersection<YieldedCalls<G>>;
export function generatorRoutine(fn) {
    return {
        async _implAsync(deps, ...args) {
            const iterator = fn({
                call: (routine, ...args) => ({
                    _tag: 'call',
                    routine,
                    args,
                }),
                success: (value) => ({ _tag: 'success', value }),
                error: (error) => ({ _tag: 'error', error }),
            }, ...args);
            let result = iterator.next();
            while (!result.done) {
                const effect = result.value;
                if (effect._tag === 'call') {
                    const resolved = '_implAsync' in effect.routine
                        ? await runAsyncRoutine(effect.routine, deps, ...effect.args)
                        : runRoutine(effect.routine, deps, ...effect.args);
                    result = iterator.next(resolved);
                }
                else if (effect._tag === 'success') {
                    return effect.value;
                }
                else if (effect._tag === 'error') {
                    throw effect.error;
                }
                else {
                    throw new Error(`Unknown yieldable effect: ${JSON.stringify(effect)}`);
                }
            }
            return result.value;
        },
    };
}
